import React from "react";
import { TemperatureAlertsDataInterface } from "../../../../../redux/interfaces/raports.interface";
import { useAppDispatch } from "../../../../../redux/hooks";
import CustomButton from "../../../../../components/CustomButton";
import SvgIcon from "../../../../../helpers/SvgIcon";
import {
  openSolvingTemperatureAlertModal,
  setSelectedTemperatureAlert,
} from "../../../../../redux/reducer/raports.reducer";

function TemperatureAlertsActionButtons({
  crudData,
}: {
  itemId: string;
  crudData: TemperatureAlertsDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();

  const handleChangePickingDate = () => {
    dispatch(setSelectedTemperatureAlert(crudData));
    dispatch(openSolvingTemperatureAlertModal());
  };

  return (
    <>
      {crudData.status === 0 && (
        <CustomButton
          variant="contained"
          className="mt-1 me-1"
          tooltipTitle="Rezolvare alerta"
          onClick={handleChangePickingDate}>
          <SvgIcon
            type="SOLVE_ALERT"
            className="svg-icon-2"
            fill="white"
            color="white"
          />
        </CustomButton>
      )}
    </>
  );
}

export default TemperatureAlertsActionButtons;
